import { useCallback, useState } from "react";
import { datesToISO } from "@";
import { useUrlSearch } from "@/shared/hooks/useUrlSearch.ts";
import type { StatisticsSearchValues, StatisticsTab } from "../types.ts";

const defaultSearchValues: StatisticsSearchValues = {
  toDate: new Date(new Date().setHours(23, 59, 59, 999)),
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
};

export const useStatisticsPage = () => { 
  const [activeTab, setActiveTab] = useState<StatisticsTab>('numbers');
 
  const {
    appliedValues,
    draftValues,
    updateDraft,
    applySearch,
    resetSearch,
    showFilters,
    setShowFilters,
  } = useUrlSearch<StatisticsSearchValues>({
    defaultValues: defaultSearchValues,
  });

  const appliedFromDate = appliedValues.fromDate
    ? datesToISO(appliedValues.fromDate)
    : "";
  const appliedToDate = appliedValues.toDate
    ? datesToISO(appliedValues.toDate)
    : "";
 
  const updateSearch = useCallback(
    (updates: { show?: boolean; values?: Partial<StatisticsSearchValues> }) => {
      if (updates.show !== undefined) setShowFilters(updates.show);
      if (updates.values) {
        Object.entries(updates.values).forEach(([key, value]) => {
          updateDraft(key as keyof StatisticsSearchValues, value);
        });
      }
    },
    [setShowFilters, updateDraft],
  );

  const handleTabChange = useCallback((tab: StatisticsTab) => {
    setActiveTab(tab);
  }, [setActiveTab]);

  return {
    activeTab,
    handleTabChange,
    search: { show: showFilters, values: draftValues },
    updateSearch,
    handleSearchSubmit: applySearch,
    handleSearchReset: resetSearch,
    appliedFromDate,
    appliedToDate,     
  };
};
